import React, { useEffect, useRef } from "react";
import gsap from "gsap";

import "./../Assets/styles/landingpage-styles.css"

const CanvasAnimation = () => {
    const canvasRef = useRef(null);
    const largeHeaderRef = useRef(null);

    useEffect(() => {
        let width, height, ctx, points, target;
        let animateHeader = true;

        function initHeader() {
            width = window.innerWidth;
            height = window.innerHeight;
            target = {
                x: width / 9,
                y: height / 14
            };

            if (largeHeaderRef.current) {
                largeHeaderRef.current.style.height = `${height}px`;
            }

            const canvas = canvasRef.current;
            if (!canvas) return;

            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext("2d");

            // Create points
            points = [];
            for (let x = 0; x < width; x += width / 9) {
                for (let y = 0; y < height; y += height / 14) {
                    let px = x + Math.random() * width / 9;
                    let py = y + Math.random() * height / 14;
                    let p = { x: px, originX: px, y: py, originY: py, closest: [] };
                    points.push(p);
                }
            }

            // Find the closest 3 points
            for (let i = 0; i < points.length; i++) {
                let p1 = points[i];
                for (let j = 0; j < points.length; j++) {
                    let p2 = points[j];
                    if (p1 !== p2) {
                        p1.closest.push(p2);
                        p1.closest.sort((a, b) => getDistance(p1, a) - getDistance(p1, b));
                        p1.closest = p1.closest.slice(0, 3);
                    }
                }
            }

            // Assign circles
            points.forEach(p => {
                p.circle = new Circle(p, 2 + Math.random() * 2, "rgb(0,0,0)");
            });

            initAnimation();
        }

        function initAnimation() {
            animate();
            points.forEach(p => shiftPoint(p));
        }

        function animate() {
            if (animateHeader && ctx) {
                ctx.clearRect(0, 0, width, height);
                points.forEach(p => {
                    const distance = getDistance(target, p);
                    if (distance < 4000) {
                        p.active = 0.3;
                        p.circle.active = 0.6;
                    } else if (distance < 20000) {
                        p.active = 0.1;
                        p.circle.active = 0.3;
                    } else {
                        p.active = 0;
                        p.circle.active = 0;
                    }

                    drawLines(p);
                    p.circle.draw();
                });
            }
            requestAnimationFrame(animate);
        }

        function shiftPoint(p) {
            gsap.to(p, {
                x: p.originX - 50 + Math.random() * 100,
                y: p.originY - 50 + Math.random() * 100,
                ease: "circ.inOut",
                duration: 1 + Math.random(),
                onComplete: () => shiftPoint(p),
            });
        }

        function drawLines(p) {
            if (!p.active || !ctx) return;
            p.closest.forEach(close => {
                ctx.beginPath();
                ctx.moveTo(p.x, p.y);
                ctx.lineTo(close.x, close.y);
                ctx.strokeStyle = `rgba(0,0,0,${p.active})`;
                ctx.stroke();
            });
        }

        function Circle(pos, rad, color) {
            this.pos = pos;
            this.radius = rad;
            this.color = color;

            this.draw = function () {
                if (!this.active || !ctx) return;
                ctx.beginPath();
                ctx.arc(this.pos.x, this.pos.y, this.radius, 0, 2 * Math.PI, false);
                ctx.fillStyle = `rgba(227,123,7,${this.active})`;
                ctx.fill();
            };
        }

        function getDistance(p1, p2) {
            return Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2);
        }

        initHeader();
    }, []);

    return (
        <div ref={largeHeaderRef} style={{ width: "100%", overflow: "hidden", top: 0, left: 0 }}>
            <canvas ref={canvasRef}></canvas>
        </div>
    );
};

export default CanvasAnimation;
